import errorAnimation from "@/assets/animations/error.lottie?arraybuffer";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

export const ErrorView = ({
  title,
  description,
}: {
  title?: string;
  description?: string;
}) => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center h-full gap-4">
      <DotLottieReact
        className="w-80"
        data={errorAnimation}
        autoplay
        loop={false}
      />
      <div className="flex flex-col items-center justify-center text-center gap-2 max-w-md mx-auto">
        <h1 className="text-xl font-bold">{title ?? "Something went wrong"}</h1>
        {description && <p>{description}</p>}
      </div>
    </div>
  );
};
